/**
 * @file
 * FlipDown countdown (hero banner and Countdown block) that stays at zero and
 * fires confetti.
 */

import confetti from 'canvas-confetti';

(function (Drupal, once) {

  'use strict';

  // Delay in ms between confetti bursts after the countdown ends.
  const CONFETTI_INTERVAL = 3000;

  function fireConfetti() {
    const defaults = { disableForReducedMotion: true, zIndex: 1100 };

    confetti({ ...defaults, particleCount: 150, spread: 90, origin: { y: 0.6 } });
    setTimeout(function () {
      confetti({ ...defaults, particleCount: 80, angle: 60, spread: 70, origin: { x: 0 } });
      confetti({ ...defaults, particleCount: 80, angle: 120, spread: 70, origin: { x: 1 } });
    }, 250);
  }

  Drupal.behaviors.ymcaTampaHeroCountdown = {
    attach: function (context, settings) {
      const { targets = {}, options = {} } = settings.flipdown || {};

      once('hero-countdown', '.hero__countdown .flipdown, .block-lb-countdown .flipdown', context).forEach(function (el) {
        const now = Math.floor(Date.now() / 1000);
        // The formatter passes NULL for dates already past; show a zero clock.
        const target = targets[el.id] || now;

        const flipdown = new FlipDown(target, el.id, {
          theme: options[el.id]?.color_theme || 'dark',
          headings: [
            Drupal.t('Days'),
            Drupal.t('Hours'),
            Drupal.t('Minutes'),
            Drupal.t('Seconds'),
          ],
        }).start();

        // Only celebrate when the countdown reaches zero while the page is
        // open, not on every load after the date has passed.
        if (target > now) {
          flipdown.ifEnded(function () {
            fireConfetti();
            setInterval(fireConfetti, CONFETTI_INTERVAL);
          });
        }
      });
    },
  };

})(Drupal, once);
